import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import EgainConstants from '../constants/EgainConstants';
import EgainUtils from '../utils/EgainUtils';

let samlToken = '';

class EgainStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  getSamlToken() {
    return samlToken;
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case EgainConstants.GET_SAML_TOKEN:
        EgainUtils.initiateEgainChat();
        break;
      case EgainConstants.GET_SAML_TOKEN_SUCCESS:
        samlToken = actionData.samlToken;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new EgainStore();
